import { render, staticRenderFns } from "./NavigationDrawer.vue?vue&type=template&id=649e598b&scoped=true&"
import script from "./NavigationDrawer.vue?vue&type=script&setup=true&lang=ts&"
export * from "./NavigationDrawer.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./NavigationDrawer.vue?vue&type=style&index=0&id=649e598b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649e598b",
  null
  
)

export default component.exports